/* eslint-disable no-nested-ternary */
import React, { useState } from 'react';

import {
  HeadingContainer, StatsGraphHeading, NoResultsHeading, LoadingSpinner,
} from '../Styles';
import DateFilterDropdown from '../DateFilterDropdown';
import PieChartGraph from '../PieChart';

import useStrings from '../../../../hooks/useStrings';
import { useGetTopLocationsByState } from '../../../../lib/graphql/queries';
import { fromDate } from '../../../../lib/Utils';

const TopLocationsState: React.FC<TopLocationsStateProps> = () => {
  const [{ Statistics: strings }] = useStrings();

  const [showDateFilter, setShowDateFilter] = useState(false);
  const [filterSelected, setFilterSelected] = useState<'week' | 'month' | 'year'>('week');

  const { data: topLocationsStateData, loading } = useGetTopLocationsByState({
    variables: { fromDate: fromDate(filterSelected) },
  });
  const topLocationsState = topLocationsStateData?.topLocationsByState.locations?.map((type) => (
    {
      name: type.state,
      value: type.count,
    }
  )) || [];

  return (
    <>
      <HeadingContainer>
        <StatsGraphHeading>{strings.donationByState}</StatsGraphHeading>
        <DateFilterDropdown
          onToggleDropdown={() => setShowDateFilter(!showDateFilter)}
          isDropdownShown={showDateFilter}
          onClickFilter={setFilterSelected}
          filterSelected={filterSelected}
        />
      </HeadingContainer>
      {loading
        ? <LoadingSpinner />
        : topLocationsState.length === 0
          ? <NoResultsHeading>{strings.noResults}</NoResultsHeading>
          : <PieChartGraph data={topLocationsState} />}
    </>
  );
};

interface TopLocationsStateProps { }

export default TopLocationsState;
